(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 33779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(36864);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/components/custom-carrusel/index.tsx
var custom_carrusel = __webpack_require__(20518);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var helpers_esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(33616);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/cardClasses.js


function getCardUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCard', slot);
}
const cardClasses = (0,generateUtilityClasses/* default */.Z)('MuiCard', ['root']);
/* harmony default export */ var Card_cardClasses = ((/* unused pure expression or super */ null && (cardClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Card/Card.js


const _excluded = ["className", "raised"];










const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardUtilityClass, classes);
};
const CardRoot = (0,styled/* default */.ZP)(Paper/* default */.Z, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/react.forwardRef(function Card(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,helpers_esm_extends/* default */.Z)({}, props, {
    raised
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardRoot, (0,helpers_esm_extends/* default */.Z)({
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = (Card);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/article-card/index.tsx







var StyledCard = (0,styled/* default */.ZP)(Card_Card)({
  margin: "auto",
  width: "100%",
  height: "auto",
  overflow: "hidden",
  display: "block",
  textOverflow: "ellipsis",
  padding: "0px 20px",
  backgroundColor: "transparent",
  boxShadow: "none",
  "@media screen and (max-width: 500px)": {
    height: "auto"
  },
  "@media screen and (max-width: 400px)": {
    padding: "0px 30px"
  }
});
var StyledCardContent = (0,styled/* default */.ZP)("div")(function (_ref) {
  var theme = _ref.theme;
  return (0,defineProperty/* default */.Z)({
    padding: "0",
    "&:last-child": {
      paddingBottom: 0
    },
    "& p": {
      color: "var(--color-brand-grey-secondary)",
      fontWeight: 400,
      fontSize: "1rem",
      textAlign: "left",
      paddingTop: "10px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 4,
      WebkitBoxOrient: "vertical"
    }
  }, theme.breakpoints.down("md"), {
    "& *": {
      textAlign: "center !important"
    }
  });
});
var Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    fontWeight: "700 !important",
    fontSize: "16px",
    minHeight: "20px",
    width: "100%",
    fontFamily: "var(--font-family)",
    color: "black !important",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical"
  };
});
var ImageWrapper = (0,styled/* default */.ZP)(Box/* default */.Z)(function (_ref4) {
  var theme = _ref4.theme;
  return (0,defineProperty/* default */.Z)({
    display: "flex"
  }, theme.breakpoints.down("md"), {
    alignItems: "center",
    justifyContent: "center"
  });
});

function ArticleCard(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: props.link,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    target: "_blank"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledCard, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ImageWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)((image_default()), {
    src: props.img,
    width: 300,
    height: 170,
    style: {
      borderRadius: "10px"
    },
    alt: "Miniatura del articulo"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(StyledCardContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, props.title), (0,emotion_react_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
    variant: "body2",
    component: "p",
    style: {
      color: "var(--color-brand-grey-main)",
      fontSize: "0.975rem"
    }
  }, props.extract)))));
}

/* harmony default export */ var article_card = (ArticleCard);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./shared/components/a1-refactor/typography/WsSectionTitleWithThinTitle copy.tsx
var WsSectionTitleWithThinTitle_copy = __webpack_require__(71099);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./api/blog-services.request.ts + 1 modules
var blog_services_request = __webpack_require__(43485);
;// CONCATENATED MODULE: ./custom-hooks/use-blog-posts.hook.ts


function useBlogPosts() {
  return (0,useQuery/* useQuery */.a)(["latestBlogPosts"], function () {
    return (0,blog_services_request/* getLatestBlogPosts */.Mw)();
  }, {
    cacheTime: 5 * 60 * 1000,
    // 5 minutes
    staleTime: 2 * 60 * 1000,
    // 2 minutes
    select: function select(response) {
      return response.data;
    }
  });
}
;// CONCATENATED MODULE: ./shared/components-pages/home/articles-blog-home-section/index.tsx











var Wrapper = (0,styled/* default */.ZP)("div")({
  width: "90%",
  margin: "auto"
});
var ContentSection = (0,styled/* default */.ZP)(Grid/* default */.ZP)(function (_ref) {
  var theme = _ref.theme;
  return {
    position: "relative",
    backgroundColor: "var(--color-brand-cream-primary)",
    padding: "5rem 4rem ",
    rowGap: "2rem",
    "@media screen and (max-width: 768px)": {
      padding: "2rem 1rem "
    }
  };
});

function ArticlesBlogHomeSection() {
  var titles = (0,next_intl_cjs_production_min.useTranslations)("home.recentArticles");

  var _useBlogPosts = useBlogPosts(),
      blogPosts = _useBlogPosts.data,
      isLoading = _useBlogPosts.isLoading,
      error = _useBlogPosts.error;

  var articlesTitle = titles("title") || "";

  var _articlesTitle$split = articlesTitle.split(" "),
      _articlesTitle$split2 = (0,toArray/* default */.Z)(_articlesTitle$split),
      title = _articlesTitle$split2[0],
      rest = _articlesTitle$split2.slice(1); // Map API response to component interface


  var articles = (blogPosts === null || blogPosts === void 0 ? void 0 : blogPosts.map(function (post) {
    return {
      title: post.title,
      extract: post.excerpt,
      link: post.url,
      img: post.image
    };
  })) || fallbackArticles;

  if (isLoading) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, "Cargando art\xEDculos...");
  }

  if (error) {
    console.error("Error loading blog posts:", error);
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)("section", null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentSection, {
    container: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitleWithThinTitle_copy/* default */.Z, {
    title: title,
    subtitle: rest.join(" ")
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(custom_carrusel/* default */.Z, null, articles.map(function (article, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(article_card, (0,esm_extends/* default */.Z)({
      key: i
    }, article));
  })))));
}

/* harmony default export */ var articles_blog_home_section = (ArticlesBlogHomeSection);
var fallbackArticles = [{
  title: "¿Cómo saber qué casa comprar?",
  extract: "Ponemos a tu disposici\xF3n documentaci\xF3n verificada y validada por profesionales del sector inmobiliario, que te ayudar\xE1 a saber qu\xE9 casa comprar.",
  link: "https://blog.remaxrd.com/finanzas/como-saber-que-casa-comprar/",
  img: "https://blog.remaxrd.com/wp-content/uploads/2022/07/Como-saber-que-casa-comprar.png"
}, {
  title: "¿Cuáles son los requisitos para recibir el Bono de Primera Vivienda?",
  extract: "Te explicamos los requisitos a completar, para recibir el bono de primera vivienda y puedas cumplir una de las metas m\xE1s importantes de tu vida.",
  link: "https://blog.remaxrd.com/sector-inmobiliario/cuales-son-los-requisitos-para-recibir-el-bono-de-primera-vivienda/",
  img: "https://blog.remaxrd.com/wp-content/uploads/2022/06/portada-blog.png"
}, {
  title: "¿Cómo conseguir un préstamo hipotecario? Te mostramos",
  extract: "Te mostramos los requisitos y recomendaciones para que puedas conseguir la aprobaci\xF3n de un pr\xE9stamo hipotecario, de forma f\xE1cil y segura.",
  link: "https://blog.remaxrd.com/sector-inmobiliario/como-conseguir-un-prestamo-hipotecario-te-mostramos/",
  img: "https://blog.remaxrd.com/wp-content/uploads/2022/07/%C2%BFComo-conseguir-un-prestamo-hipotecario.png"
}, {
  title: "¿Cómo mejorar tu historial crediticio para financiar tu casa?",
  extract: "Para poder conseguir un pr\xE9stamos, hay diversos factores que se toman en cuenta. \xBFEl m\xE1s importante? Mejorar tu historial crediticio o score crediticio.",
  link: "https://blog.remaxrd.com/finanzas/como-mejorar-tu-historial-crediticio-para-financiar-tu-casa/",
  img: "https://blog.remaxrd.com/wp-content/uploads/2022/07/portada-blog-historial-crediticio.png"
}];
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/cardContentClasses.js


function getCardContentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiCardContent', slot);
}
const cardContentClasses = (0,generateUtilityClasses/* default */.Z)('MuiCardContent', ['root']);
/* harmony default export */ var CardContent_cardContentClasses = ((/* unused pure expression or super */ null && (cardContentClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/CardContent/CardContent.js


const CardContent_excluded = ["className", "component"];








const CardContent_useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,composeClasses/* default */.Z)(slots, getCardContentUtilityClass, classes);
};
const CardContentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/react.forwardRef(function CardContent(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, CardContent_excluded);
  const ownerState = (0,helpers_esm_extends/* default */.Z)({}, props, {
    component
  });
  const classes = CardContent_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardContentRoot, (0,helpers_esm_extends/* default */.Z)({
    as: component,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = (CardContent);
;// CONCATENATED MODULE: ./shared/components-pages/home/cities-home-section/index.tsx










var CitiesSection = (0,styled/* default */.ZP)(Grid/* default */.ZP)(function (_ref) {
  var theme = _ref.theme;
  return {
    width: "100%",
    minHeight: "50vh",
    backgroundColor: "#fff",
    padding: "5rem 4rem",
    "@media screen and (max-width: 768px)": {
      padding: "2rem 1rem"
    }
  };
});
var CityCard = (0,styled/* default */.ZP)(Card_Card)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    maxWidth: 300,
    display: "inline-block",
    margin: "0 10px 10px",
    boxShadow: "none",
    backgroundColor: "transparent",
    textAlign: "center",
    textDecoration: "none",
    "& a": {
      textDecoration: "none"
    }
  };
});
var CityImage = (0,styled/* default */.ZP)("img")({
  maxWidth: 135,
  width: "100%",
  height: 135,
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  borderRadius: "50%",
  marginBottom: 10
});
var CityTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)({
  color: "#808080",
  fontWeight: 500,
  fontSize: "15.6px !important"
});
var ContentCities = (0,styled/* default */.ZP)(Box/* default */.Z)({
  display: "flex !important",
  justifyContent: "center"
});

function CitiesHomeSection() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("home.cities");
  var citiesTitles = translation("title");

  var _citiesTitles$split = citiesTitles.split(" "),
      _citiesTitles$split2 = (0,toArray/* default */.Z)(_citiesTitles$split),
      title = _citiesTitles$split2[0],
      rest = _citiesTitles$split2.slice(1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(CitiesSection, {
    container: true,
    rowGap: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitleWithThinTitle_copy/* default */.Z, {
    title: title,
    subtitle: rest.join(" ")
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    position: "relative"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(custom_carrusel/* default */.Z, null, cities.map(function (city, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCities, {
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: city.link,
      passHref: true
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
      component: "a",
      sx: {
        textDecoration: "none"
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(CityCard, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardContent_CardContent, {
      sx: {
        padding: 0
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(CityImage, {
      src: city.image,
      alt: city.label
    }), (0,emotion_react_browser_esm/* jsx */.tZ)(CityTitle, {
      variant: "h6"
    }, city.label))))));
  }))));
}

/* harmony default export */ var cities_home_section = (CitiesHomeSection);
var cities = [{
  label: "La Romana",
  image: "/images/la_romana_remax_rd.png",
  link: pages_path/* CPagesPath.es.properties */.K.es.properties + "?businessTypes=sale&currencyType=us&locations[]=id-60%26description-LA%20ROMANA%26"
}, {
  label: "Punta Cana",
  image: "/images/punta_cana_remax_rd.png",
  link: pages_path/* CPagesPath.es.properties */.K.es.properties + "?businessTypes=sale&currencyType=us&locations[]=id-434%26description-PUNTA%20CANA%26"
}, {
  label: "Santo Domingo",
  image: "/images/santo_domingo_remax_rd.png",
  link: pages_path/* CPagesPath.es.properties */.K.es.properties + "?businessTypes=sale&currencyType=us&locations[]=id-1%26description-SANTO%20DOMINGO%20DE%20GUZM\xC1N%26"
}, {
  label: "Samaná",
  image: "/images/samana_remax_rd.png",
  link: pages_path/* CPagesPath.es.properties */.K.es.properties + "?businessTypes=sale&currencyType=us&locations[]=id-93%26description-SAMAN\xC1%26"
}, {
  label: "Santiago",
  image: "/images/santiago_remax_rd.png",
  link: pages_path/* CPagesPath.es.properties */.K.es.properties + "?businessTypes=sale&currencyType=us&locations[]=id-120%26description-SANTIAGO%26"
}, {
  label: "Puerto Plata",
  image: "/images/puerto_plata_remax_rd.png",
  link: pages_path/* CPagesPath.es.properties */.K.es.properties + "?businessTypes=sale&currencyType=us&locations[]=id-81%26description-PUERTO%20PLATA%26"
}];
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./shared/components/slider-collection-property/index.tsx
var slider_collection_property = __webpack_require__(2098);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./shared/components/Typography/index.tsx
var components_Typography = __webpack_require__(85127);
// EXTERNAL MODULE: ./shared/components/a1-refactor/typography/WsSectionTitle.tsx
var WsSectionTitle = __webpack_require__(45423);
;// CONCATENATED MODULE: ./shared/components-pages/home/collection-home-section/index.tsx


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;















function CollectionHomeSection() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("home.collection");
  var isMobile = (0,useMediaQuery/* default */.Z)("(max-width: 768px)");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    position: "relative",
    zIndex: 2,
    sx: {
      backgroundColor: "var(--color-brand-cream-primary)"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Collection, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ColletionHeader, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CollectionLogo, null, !isMobile && (0,emotion_react_browser_esm/* jsx */.tZ)(CollectionLogoImage, {
    src: "images/v2/logos/collection-01.png",
    alt: "Logo Remax Collection"
  }), isMobile && (0,emotion_react_browser_esm/* jsx */.tZ)(CollectionLogoImage, {
    src: "images/v2/logos/collection-02.png",
    alt: "Logo Remax Collection"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(CollectionDescription, null, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitle/* default */.Z, {
    title: "".concat(translation("title"), " ").concat(translation("subtitle")),
    color: "white"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Description, {
    className: "m-v-20",
    fontSize: "--fs-body-small",
    color: "--color-brand-bg-secondary",
    fontWeight: 400
  }, translation("description")))), (0,emotion_react_browser_esm/* jsx */.tZ)(slider_collection_property/* default */.Z, null), (0,emotion_react_browser_esm/* jsx */.tZ)(CollectionButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection */.K.es.collection,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, " ", translation("seeMore")))))));
}

/* harmony default export */ var collection_home_section = (CollectionHomeSection);
var collection_home_section_Title = (0,styled/* default */.ZP)(components_Typography/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  white-space: nowrap;\n  font-size: 1.8rem;\n"])));
var Description = (0,styled/* default */.ZP)(components_Typography/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 1rem;\n"])));
var CollectionButton = (0,styled/* default */.ZP)("article")(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  margin: auto;\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n"])));
var Collection = (0,styled/* default */.ZP)(Grid/* default */.ZP)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  background-color: var(--color-brand-blue-collection-main);\n  border-radius: 150px 0 0 0;\n  padding-top: 150px;\n  padding-bottom: 100px;\n\n  @media screen and (max-width: 991px) {\n    padding-bottom: 50px;\n    padding-top: 50px;\n  }\n\n  @media screen and (max-width: 767px) {\n    border-radius: 0;\n  }\n\n  @media screen and (max-width: 575px) {\n    padding-top: 120px;\n  }\n\n  @media screen and (max-width: 485px) {\n    padding-top: 90px;\n  }\n"])));
var ColletionHeader = (0,styled/* default */.ZP)("section")(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  margin-bottom: 70px;\n\n  @media screen and (max-width: 991px) {\n    flex-wrap: wrap;\n  }\n\n  @media screen and (max-width: 575px) {\n    margin-bottom: 50px;\n  }\n"])));
var CollectionLogo = (0,styled/* default */.ZP)("div")(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 40%;\n  align-self: center;\n  text-align: center;\n\n  @media screen and (max-width: 991px) {\n    margin-bottom: 30px;\n    width: 100%;\n    max-width: 550px;\n    margin-right: auto;\n    margin-left: auto;\n    padding: 0px 20px;\n  }\n"])));
var CollectionLogoImage = (0,styled/* default */.ZP)("img")(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 180px;\n  height: auto;\n  @media screen and (max-width: 991px) {\n    width: 100%;\n    max-width: 200px;\n  }\n"])));
var CollectionDescription = (0,styled/* default */.ZP)("div")(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  row-gap: 2rem;\n\n  @media screen and (max-width: 991px) {\n    width: 100%;\n    max-width: 550px;\n    margin-right: auto;\n    margin-left: auto;\n    padding: 0px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n"])));
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./styles/theme/theme.tsx
var theme = __webpack_require__(6412);
;// CONCATENATED MODULE: ./shared/components-pages/home/cover/index.tsx






var Logo = (0,styled/* default */.ZP)(Avatar/* default */.Z)(function (_ref) {
  var theme = _ref.theme;
  return (0,defineProperty/* default */.Z)({
    width: 440,
    height: "auto",
    objectFit: "contain",
    margin: "0 auto"
  }, theme.breakpoints.down("sm"), {
    width: 340
  });
});

function Cover(_ref3) {
  var children = _ref3.children;
  var translation = (0,next_intl_cjs_production_min.useTranslations)("home");
  var isMobile = (0,useMediaQuery/* default */.Z)(theme/* default.breakpoints.down */.Z.breakpoints.down("sm"));
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      position: "relative",
      padding: "40px 0 0 0",
      marginBottom: 0,
      zIndex: 1,
      backgroundColor: "var(--color-brand-cream-primary)"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      backgroundColor: "#aa9d89",
      width: "100%",
      height: {
        xs: 360,
        sm: 450
      },
      borderRadius: {
        xs: 0,
        sm: "0 0 0 200px"
      },
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 2
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      width: {
        xs: "100%",
        sm: "85%"
      },
      height: {
        xs: 380,
        sm: 500,
        md: 600
      },
      borderRadius: "60px",
      overflow: "hidden",
      display: "grid",
      justifyContent: "center",
      alignContent: "flex-start",
      paddingTop: {
        xs: 1,
        sm: 5,
        md: 10
      },
      backgroundImage: "url('/images/image-optimize/living.webp')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      margin: "0 auto",
      position: "relative",
      zIndex: 3
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      marginTop: {
        xs: 6,
        sm: 4
      },
      marginBottom: {
        xs: 2,
        sm: 4
      }
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Logo, {
    src: isMobile ? "/images/v2/logos/10.png" : "/images/v2/logos/9.png",
    alt: "Logo Re/max",
    variant: "square"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    component: "p",
    sx: {
      color: "white",
      fontSize: {
        xs: "1.2rem",
        sm: "1.4rem",
        md: "1.6rem"
      },
      textAlign: "center",
      fontWeight: 400,
      "& span": {
        fontFamily: "var(--font-family-extra), sans-serif",
        color: "#fff",
        fontSize: {
          xs: "1.2rem",
          sm: "1.4rem"
        },
        position: "relative",
        bottom: "-20px"
      }
    }
  }, translation.rich("title", {
    span: function span(chunks) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, chunks);
    }
  }))), children));
}

/* harmony default export */ var cover = (Cover);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
;// CONCATENATED MODULE: ./shared/components-pages/home/franchises-home-section/index.tsx











var FranchiseContainer = (0,styled/* default */.ZP)("article")(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    paddingTop: "200px",
    height: "800px",
    backgroundColor: "#fff",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundImage: 'url("/images/v2/pic/image-02.jpeg")'
  }, (0,defineProperty/* default */.Z)(_ref2, theme.breakpoints.down("md"), {
    backgroundImage: "none !important",
    paddingTop: "100px",
    paddingBottom: "40px",
    height: "auto"
  }), (0,defineProperty/* default */.Z)(_ref2, theme.breakpoints.down("sm"), {
    paddingTop: "20px"
  }), _ref2;
});
var FranchiseDetails = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var _ref4;

  var theme = _ref3.theme;
  return _ref4 = {
    padding: "0px 107px",
    maxWidth: "618px",
    marginLeft: "auto",
    fontWeight: 400,
    color: "var(--color-brand-grey-main)",
    fontSize: "0.938rem"
  }, (0,defineProperty/* default */.Z)(_ref4, theme.breakpoints.down("lg"), {
    padding: "0px 55px",
    maxWidth: "415px"
  }), (0,defineProperty/* default */.Z)(_ref4, theme.breakpoints.down("md"), {
    marginRight: "auto",
    padding: "0px 0px"
  }), (0,defineProperty/* default */.Z)(_ref4, theme.breakpoints.down("sm"), {
    padding: "0px 20px"
  }), _ref4;
});
var TextInfo = (0,styled/* default */.ZP)("p")(function (_ref5) {
  var theme = _ref5.theme;
  return (0,defineProperty/* default */.Z)({
    textShadow: "1px 0px 0.5px #fffa",
    color: "var(--color-text-black)",
    fontWeight: 400,
    fontSize: "1rem",
    margin: "15px 0px",
    fontFamily: "var(--font-family)"
  }, theme.breakpoints.down("md"), {
    textAlign: "center"
  });
});
var ContentBtn = (0,styled/* default */.ZP)("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  marginTop: "1.8rem",
  "& a": {
    minWidth: "260px",
    margin: "0.5rem 0px"
  }
});

function FranchisesHomeSection() {
  var width = (0,use_width_hook/* useWidth */.z)();
  var translation = (0,next_intl_cjs_production_min.useTranslations)("home.franchise");
  var franchiseTitle = translation("title") || "";

  var _franchiseTitle$split = franchiseTitle.split(" "),
      _franchiseTitle$split2 = (0,toArray/* default */.Z)(_franchiseTitle$split),
      title = _franchiseTitle$split2[0],
      rest = _franchiseTitle$split2.slice(1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(FranchiseContainer, {
    className: "franchise"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(FranchiseDetails, {
    className: "franchise__details"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
    src: "/images/v2/logos/5.png",
    sx: {
      width: "100%",
      maxWidth: "400px",
      height: "140px",
      margin: "0 auto",
      marginBottom: "-1.5rem",
      marginLeft: "-10px",
      objectFit: "contain"
    },
    variant: "square"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(TextInfo, null, translation("network")), (0,emotion_react_browser_esm/* jsx */.tZ)(TextInfo, null, translation("advantage")), (0,emotion_react_browser_esm/* jsx */.tZ)(TextInfo, null, translation("develop")), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentBtn, {
    className: "franchise__btn"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.franchises */.K.es.franchises
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    bg: "--color-brand-red-tertiary"
  }, translation("openFranchise"))), (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.join */.K.es.join
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    bg: "--color-brand-red-main"
  }, translation("joinUs")))))));
}

/* harmony default export */ var franchises_home_section = (FranchisesHomeSection);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
;// CONCATENATED MODULE: ./shared/components-pages/home/lending-home-section/index.tsx



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









function LendingHomeSection() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("home.mortgage");
  var lendingTitle = translation("title") || "";

  var _lendingTitle$split = lendingTitle.split(" "),
      _lendingTitle$split2 = (0,toArray/* default */.Z)(_lendingTitle$split),
      title = _lendingTitle$split2[0],
      rest = _lendingTitle$split2.slice(1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(LendingHomeSectionContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(SpaceWhite, null), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentTitle, null, (0,emotion_react_browser_esm/* jsx */.tZ)(SubContentTitle, null, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitleWithThinTitle_copy/* default */.Z, {
    title: title,
    subtitle: rest.join(" "),
    color: "white"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentBody, null, (0,emotion_react_browser_esm/* jsx */.tZ)(SubContentBody, null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, translation("subtitle")), (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, translation("description")), (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, translation("alliance")), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.loan_form */.K.es.loan_form + "#loanForm",
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, translation("applyForLoan")))))), (0,emotion_react_browser_esm/* jsx */.tZ)(WRapperCurveContent, null), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(WRapperImage, {
    src: "/images/image-optimize/black-couple.webp",
    width: 100,
    height: 200,
    alt: "Pareja que adquiriendo una casa "
  })));
}

/* harmony default export */ var lending_home_section = (LendingHomeSection);

var LendingHomeSectionContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c10"
} : 0)( true ? {
  name: "kfmk3k",
  styles: "position:relative;width:100%;background-image:white;height:auto"
} : 0);

var SpaceWhite = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c9"
} : 0)( true ? {
  name: "11uas09",
  styles: "width:100%;background:var(--color-brand-cream-primary);height:100px;@media screen and (max-width: 900px){display:none;}"
} : 0);

var ContentTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c8"
} : 0)( true ? {
  name: "15lxzjr",
  styles: "width:100%;background-color:black;height:180px;display:flex;align-items:center"
} : 0);

var SubContentTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c7"
} : 0)( true ? {
  name: "xjy8nl",
  styles: "width:600px;@media screen and (max-width: 2000px){margin:6.5vw;}@media screen and (max-width: 2000px){margin:6.5vw;}@media screen and (max-width: 1445px){margin:4vw;}@media screen and (max-width: 1000px){width:100%;margin:0;padding:2rem;}@media screen and (max-width: 900px){}@media screen and (max-width: 400px){width:100%;margin:0;padding:0rem;text-align:center;}"
} : 0);

var SubContentBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c6"
} : 0)( true ? {
  name: "p5k8qj",
  styles: "width:600px;margin:11.5vw;@media screen and (max-width: 1000px){width:100%;margin:0;padding:2rem;text-align:center;}@media screen and (max-width: 900px){}@media screen and (max-width: 400px){}"
} : 0);

var TitleLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1844g7c5"
} : 0)( true ? {
  name: "189s84k",
  styles: "margin:0px!important;color:white;font-weight:600;font-size:40px;span{font-weight:400;margin-left:10px;font-size:40px;}@media screen and (max-width: 900px){font-size:24px;span{font-size:24px;}}@media screen and (max-width: 400px){margin:0px!important;font-size:30px;span{font-size:20px;}}"
} : 0);

var ContentBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c4"
} : 0)( true ? {
  name: "myq8cn",
  styles: "width:100%;height:360px;background-color:var(--color-brand-cream-primary);display:flex;align-items:center"
} : 0);

var ContentButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c3"
} : 0)( true ? {
  name: "1a6o1jv",
  styles: "display:flex;justify-content:center;align-items:center;margin:40px"
} : 0);

var WRapperCurveContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c2"
} : 0)( true ? {
  name: "10wkxfl",
  styles: "position:absolute;z-index:10;right:0;bottom:0;background-color:var(--color-brand-blue-secondary);border-radius:350px 0 0 0;width:35%;height:100%;@media screen and (max-width: 1100px){display:none;}"
} : 0);

var ContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1844g7c1"
} : 0)( true ? {
  name: "1npza4q",
  styles: "position:relative;width:100%;background-color:red;float:right"
} : 0);

var WRapperImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1844g7c0"
} : 0)( true ? {
  name: "jvys2w",
  styles: "position:absolute;z-index:11;right:0;bottom:0;width:525px;height:702px;transform:translate(-12vw, 61px);@media screen and (max-width: 1285px){}@media screen and (max-width: 1135px){}@media screen and (max-width: 1100px){display:none;}@media screen and (max-width: 1100px){}@media screen and (max-width: 900px){}"
} : 0);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(95627);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./api/realestate.request.ts + 1 modules
var realestate_request = __webpack_require__(13897);
// EXTERNAL MODULE: ./shared/components/messages-result/index.tsx
var messages_result = __webpack_require__(52659);
// EXTERNAL MODULE: ./shared/components/property-card/index.tsx + 1 modules
var property_card = __webpack_require__(39470);
// EXTERNAL MODULE: ./shared/components/skeletons/property-collector-card.skeleton.tsx
var property_collector_card_skeleton = __webpack_require__(58254);
// EXTERNAL MODULE: ./custom-hooks/useGetPersintParamas.hook.ts
var useGetPersintParamas_hook = __webpack_require__(53541);
// EXTERNAL MODULE: ./custom-hooks/useWindowsSize.hook.js
var useWindowsSize_hook = __webpack_require__(51860);
;// CONCATENATED MODULE: ./shared/components-pages/home/property-slider-home-section/index.tsx






function property_slider_home_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















function PropertySliderHomeSection() {
  var _data$data, _data$data2, _data$data3;

  var translation = (0,next_intl_cjs_production_min.useTranslations)("home.exclusiveProperties");
  var sliderTitle = translation("title") || "";
  var size = (0,useWindowsSize_hook/* default */.Z)();
  var width = size === null || size === void 0 ? void 0 : size.width;

  var fetchProjectSlider = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,realestate_request/* getRealestate */._G)({
                page: 1,
                exclusives: true
              });

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProjectSlider(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var ref = (0,useGetPersintParamas_hook/* default */.Z)();

  var _useMutation = (0,useMutation/* useMutation */.D)(["project-slider"], fetchProjectSlider),
      data = _useMutation.data,
      status = _useMutation.status,
      isLoading = _useMutation.isLoading,
      isError = _useMutation.isError,
      mutate = _useMutation.mutate;

  react.useEffect(function () {
    mutate({});
  }, []);

  if (data && (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.length) > 0 && isLoading) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Sin Resultados"
    });
  }

  if (isError) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Ha ocurrido un error"
    });
  }

  var _sliderTitle$split = sliderTitle.split(" "),
      _sliderTitle$split2 = (0,slicedToArray/* default */.Z)(_sliderTitle$split, 2),
      title = _sliderTitle$split2[0],
      subtitle = _sliderTitle$split2[1];

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("article", {
    style: {
      background: "var(--color-brand-cream-primary)"
    },
    className: "jsx-1352719154" + " " + "properties_slider"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "jsx-1352719154" + " " + "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    justifyContent: "center",
    mt: 3,
    mb: 7
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitleWithThinTitle_copy/* default */.Z, {
    title: title,
    subtitle: subtitle
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(custom_carrusel/* default */.Z, {
    enablePlaceholder: true,
    placeholderItem: (0,emotion_react_browser_esm/* jsx */.tZ)(property_collector_card_skeleton/* default */.Z, null),
    numberOfPlaceholderItems: 4,
    forcePlaceHolder: data && (data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.length) == 0 && isLoading
  }, data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.map(function (property, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      key: i,
      href: pages_path/* CPagesPath.es.property_detail */.K.es.property_detail(property) + ref,
      passHref: true
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(CardWrapper, {
      key: i,
      target: width > 991 ? "_blank" : "",
      rel: "nofollow noopener noreferrer"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(property_card/* default */.Z, property)));
  })))), (0,emotion_react_browser_esm/* jsx */.tZ)((style_default()), {
    id: "1352719154"
  }, [".properties_slider.jsx-1352719154{width:100%;padding:50px 100px;}", ".content_Card.jsx-1352719154{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", "@media screen and (max-width:991px){.properties_slider.jsx-1352719154{padding-left:0;padding-right:0;}}", "@media screen and (max-width:501px){}"]));
}

/* harmony default export */ var property_slider_home_section = (PropertySliderHomeSection);

var property_slider_home_section_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e4ztf8v1"
} : 0)( true ? {
  name: "8vxm8h",
  styles: "width:100%;padding:50px 0;margin-bottom:50px"
} : 0);

var CardWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e4ztf8v0"
} : 0)( true ? {
  name: "1dy7i53",
  styles: "display:flex;justify-content:center;margin:5px"
} : 0);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./shared/components-pages/home/proyect-home-section/index.tsx












var ProjectsWrapper = (0,styled/* default */.ZP)(Box/* default */.Z)(function (_ref) {
  var theme = _ref.theme;
  return {
    position: "relative",
    zIndex: 0,
    width: "100%",
    height: "calc(100vh - 73px)"
  };
});
var ContentPicture = (0,styled/* default */.ZP)(Box/* default */.Z)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    width: "100%",
    height: "100%",
    backgroundImage: "url(/images/v2/pic/image-01.jpeg)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    transform: "rotateY(180deg)",
    position: "relative",
    zIndex: 1
  };
});
var ProjectDetails = (0,styled/* default */.ZP)("div")(function (_ref3) {
  var _ref4;

  var theme = _ref3.theme;
  return _ref4 = {
    width: "48%",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    zIndex: 2,
    right: 0,
    bottom: 0,
    backgroundColor: "var(--color-brand-cream-primary)",
    borderRadius: "50px 0 0 0",
    padding: "2rem 3rem",
    boxShadow: "none"
  }, (0,defineProperty/* default */.Z)(_ref4, theme.breakpoints.down("lg"), {
    width: "60%",
    padding: "2.5rem 3rem"
  }), (0,defineProperty/* default */.Z)(_ref4, theme.breakpoints.down("md"), {
    width: "100%",
    borderRadius: 0,
    padding: "2rem 3rem",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    minHeight: "calc((100vh - 73px) / 3)"
  }), (0,defineProperty/* default */.Z)(_ref4, theme.breakpoints.down("sm"), {
    padding: "2rem 1rem",
    minHeight: "calc((100vh - 73px) / 3)"
  }), (0,defineProperty/* default */.Z)(_ref4, theme.breakpoints.down("xs"), {
    padding: "2rem 0.5rem"
  }), _ref4;
});
var LinkContentBox = (0,styled/* default */.ZP)(Box/* default */.Z)(function (_ref5) {
  var theme = _ref5.theme;
  return {};
});

function ProyectHomeSection() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("home.projects");
  var referer = (0,useGetPersintParamas_hook/* default */.Z)({
    useConque: "&"
  });
  var theme = (0,useTheme/* default */.Z)();
  var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
  var benefits = [translation("benefitsOne"), translation("benefitsTwo"), translation("benefitsThree"), translation("benefitsFour"), translation("benefitsFive")];
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ProjectsWrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentPicture, null), (0,emotion_react_browser_esm/* jsx */.tZ)(ProjectDetails, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    mb: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    mb: {
      xs: 0,
      md: -0.5
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitle/* default */.Z, {
    title: translation("title")
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Subtitle, null, translation("subtitle")))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    item: true,
    xs: 12,
    sx: {
      marginTop: "1rem",
      paddingLeft: {
        md: "0"
      }
    },
    pl: 2,
    component: "ul"
  }, benefits.map(function (benefit, index) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      key: index,
      component: "li"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(components_Typography/* default */.Z, {
      sx: {
        color: "var(--color-text-black)",
        fontSize: 14,
        fontWeight: 400,
        listStyle: "disc",
        listStylePosition: "inside",
        textAlign: {
          xs: "left"
        }
      }
    }, benefit));
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(LinkContentBox, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.project */.K.es.project + "?businessTypes=sale&typeProperty[]=project" + referer,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    variant: "contained",
    bg: "--color-brand-red-tertiary"
  }, translation("seeProject"))))));
}

/* harmony default export */ var proyect_home_section = (ProyectHomeSection);
var proyect_home_section_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref6) {
  var theme = _ref6.theme;
  return (0,defineProperty/* default */.Z)({
    color: "var(--color-text-black)",
    fontSize: 40,
    fontWeight: "bold"
  }, theme.breakpoints.down("md"), {
    fontSize: "24px"
  });
});
var Subtitle = (0,styled/* default */.ZP)(Typography/* default */.Z)(function (_ref8) {
  var theme = _ref8.theme;
  return (0,defineProperty/* default */.Z)({
    color: "var(--color-text-black)",
    fontSize: "20.8px",
    marginTop: 0,
    fontWeight: 400
  }, theme.breakpoints.down("md"), {
    fontSize: "16px"
  });
});
// EXTERNAL MODULE: ./shared/components/buy-sell-filter/index.tsx + 1 modules
var buy_sell_filter = __webpack_require__(97814);
// EXTERNAL MODULE: ./shared/components/head-meta/index.tsx
var head_meta = __webpack_require__(23385);
// EXTERNAL MODULE: ./shared/models/const/keywords.const.ts
var keywords_const = __webpack_require__(6644);
// EXTERNAL MODULE: ./shared/components/layout/index.tsx + 40 modules
var layout = __webpack_require__(85393);
;// CONCATENATED MODULE: ./pages/index.tsx















var Home = function Home(props) {
  var metaData = {
    keyWords: keywords_const/* CKeyWordsPages.home */.k.home,
    description: "home",
    url: "/",
    title: "home",
    picture: "/images/image-optimize/living_meta.jpg"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(layout/* default */.Z, {
    showFooter: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(head_meta/* default */.Z, metaData), (0,emotion_react_browser_esm/* jsx */.tZ)(cover, null, (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter/* default */.Z, {
    detailsRoute: pages_path/* CPagesPath.es.property_detail */.K.es.property_detail
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(property_slider_home_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(collection_home_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(proyect_home_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(franchises_home_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(articles_blog_home_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(lending_home_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(cities_home_section, null));
};

var __N_SSG = true;
/* harmony default export */ var pages = (Home);

/***/ }),

/***/ 85127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36864);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);




/**
 *
 * @description Typography component
 * default styles are
 * --font-size body medium,
 *  color --color-brand-grey-main
 *  and weight 400
 * @returns
 */



var Typography = function Typography(props) {
  var _ref, _props$fontWeight;

  var styles = {
    root:
    /*#__PURE__*/

    /*#__PURE__*/
    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
      fontFamily: "var(--font-family)",
      fontSize: props.fontSize ? "var(".concat(props.fontSize, ")") : "var(--fs-body-medium)",
      color: (_ref = "var(".concat(props.color, ")")) !== null && _ref !== void 0 ? _ref : "var(--color-brand-grey-main)",
      fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 400
    },  true ? "" : 0,  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    css: styles.root
  }, props), props.children);
};

/* harmony default export */ __webpack_exports__["Z"] = (Typography);

/***/ }),

/***/ 45423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11496);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15861);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70917);


var _templateObject;




function WsSectionTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      color = _ref.color,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "1.6rem" : _ref$fontSize;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 700,
    color: color
  }, title);
}

/* harmony default export */ __webpack_exports__["Z"] = (WsSectionTitle);
var Title = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  text-align: center;\n  text-wrap: wrap;\n  font-size: 1.8rem;\n  @media screen and (max-width: 768px) {\n    font-size: 1.4rem;\n  }\n"])));

/***/ }),

/***/ 71099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11496);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70917);


var _templateObject;




function WsSectionTitleWithThinTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      color = _ref.color,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "1.6rem" : _ref$fontSize;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center",
    spacing: 1
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    item: true,
    xs: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 700,
    color: color
  }, title)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    item: true,
    xs: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 400,
    color: color
  }, subtitle)));
}

/* harmony default export */ __webpack_exports__["Z"] = (WsSectionTitleWithThinTitle);
var Title = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  font-size: 1.8rem;\n  @media screen and (max-width: 768px) {\n    font-size: 1.4rem;\n  }\n"])));

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 58254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86886);
/* harmony import */ var _mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88078);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);





function PropertyCardCollectionSkeleton() {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    flexDirection: "column"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    variant: "rectangular",
    width: 300,
    height: 140,
    style: {
      borderRadius: 10
    }
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    container: true,
    marginBottom: 1
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "68%",
    height: 40
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 20
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "50%",
    height: 30
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 30
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material_Skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    width: "80%",
    height: 30
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (PropertyCardCollectionSkeleton);

/***/ }),

/***/ 6644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CKeyWordsPages; }
/* harmony export */ });
var CKeyWordsPages = {
  project: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana",
  join: "conviértete en agente inmobiliario remax, únete a remax república dominicana, agente inmobiliario remax, agencia inmobiliaria, agente inmobiliario, agente Remax",
  page404: "pagina no encontrada",
  home: "inmueble, remax rd, remax república dominicana, alquilar una casa, comprar una casa, comercialización de inmuebles, proyectos en construcción, beneficios de comprar en planos, préstamos hipotecarios, préstamos hipotecarios en república dominicana, franquicia remax, Propiedades destacadas, propiedades de Remax RD, propiedades de remax república dominicana, agente inmobliario, agencia inmobiliaria, propiedades en República Dominicana, alquiler apartamento, bienes raices santo domingo, departamentos en alquiler santo domingo, proyectos de apartamentos en punta cana, alquilar casa, apartamentos en santo domingo este, apartamentos en bavaro, apartamento en venta punta cana, apartamentos en rd, apartamentos en alquiler santo domingo este, proyectos de apartamentos económicos en santo domingo, apartamentos en venta san isidro, apartamentos en venta republica dominicana, apartamentos en alquiler en santo domingo distrito nacional, apartamento en alquiler, casas en alquiler en república dominicana, proyectos de apartamentos en santo domingo distrito nacional, venta de propiedades en republica dominicana, casas rd, venta de casas en santo domingo, apartamento en el millon, alquiler de apartamentos en santo domingo distrito nacional, comprar apartamento en santo domingo, compra de apartamentos en santo domingo, apartamentos en La Romana",
  homeCollections: "Remax collection, propiedades de lujo, propiedades exclusivas, propiedades premium, propiedades collection",
  mortgageLoad: "préstamo hipotecario, Calculadora de prestamos, cuota de préstamos hipotecarios, formulario de prestamos",
  iWantToRent: "casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almacén en alquiler, villas en alquiler, alquiler de aparta estudio, proyectos exclusivos de remax república dominicana",
  iWantToBuy: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana, compra inmobiliaria, adquir propiedad inmobiliaria, inversion inmobiliaria en república dominicana, inversión inmobiliaria"
};

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(33779);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3828,8584,8360,2966,2203,6869,3405,8654,9470,4003,1691,2098,7814,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);